import { render, staticRenderFns } from "./CampaignOneCropUnit.vue?vue&type=template&id=2c0b3283&scoped=true"
import script from "./CampaignOneCropUnit.vue?vue&type=script&lang=js"
export * from "./CampaignOneCropUnit.vue?vue&type=script&lang=js"
import style0 from "./CampaignOneCropUnit.vue?vue&type=style&index=0&id=2c0b3283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b3283",
  null
  
)

export default component.exports